/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import React from 'react';
import type { NestedFinding } from './mapping-issues';

/**
 * **The findings inside an open row, for the places the editor draws** (`3i`, `#1412`).
 *
 * `MappingRow` provides it from the row's own `severity`, which every surface already computes with
 * `rowSeverity`; the expression editor's location wrapper reads it and marks the place a finding
 * points at. Context rather than a prop for the reason the location itself is one: the editor's forms
 * nest through each other, and a prop threaded through all of them is a prop one of them drops. And
 * no surface has to pass anything new, so none can forget to.
 *
 * `null` outside a row, where nothing is marked.
 */
export const RowNestedFindingsContext = React.createContext<ReadonlyMap<string, NestedFinding> | null>(null);
